export * from './entry-main-image';
